"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      height: 24,
      borderRadius: 3,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.grey[500],
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 60,
      transition: theme.transitions.create(["border-color", "border-width", "padding-left", "padding-right"], {
        duration: theme.transitions.duration.standard
      })
    },
    selected: {
      borderColor: theme.palette.secondary.main,
      paddingLeft: 11,
      paddingRight: 11,
      borderWidth: 2
    },
    ripple: {
      backgroundColor: theme.palette.secondary.main
    }
  };
});
/**
 * **The size selector button has two states, selected and unselected. It enables the user to freely choose which capacity device they want. One capacity will always be preselected when there are more than one option.**
 *
 * There is 1 state: selected
 */

var PickerSize = function PickerSize(_ref) {
  var _classNames;

  var text = _ref.text,
      selected = _ref.selected,
      action = _ref.action;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    color: "primary",
    onClick: function onClick() {
      return action();
    },
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.selected, selected), _classNames)),
    TouchRippleProps: {
      classes: {
        child: styles.ripple
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: text,
    variant: "body"
  }));
};

PickerSize.propTypes = {
  /** The text of the picker */
  text: _propTypes.default.string.isRequired,

  /** The selected state of the picker */
  selected: _propTypes.default.bool,

  /** Action to call when click the picker */
  action: _propTypes.default.func.isRequired
};
PickerSize.defaultProps = {
  selected: false
};
var _default = PickerSize;
exports.default = _default;